import styled from 'styled-components';
import { CartClose } from '../../__partials/CartClose';

export const Close = styled(CartClose)`
  margin-left: auto;
`;

export const ErrorMessage = styled.div`
  font-size: var(--ft-font-size-300);
  line-height: var(--ft-line-height-100);
  color: var(--v3-error-color);
  padding: 30px;

  a {
    color: var(--v3-primary-color);
  }
`;
